import { render } from "./sandboxTips.vue?vue&type=template&id=338226ca&scoped=true"
const script = {}

import "./sandboxTips.vue?vue&type=style&index=0&id=338226ca&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338226ca"]])

export default __exports__